import { WifiOff } from 'lucide-react';
import { useColaboracao } from '../../application/dependencias';
import { Avatar } from '../design-system/Avatar';

const VISIVEIS = 5;

/** Quem está online no quadro agora (RQ-COL-003); sem conexão, avisa. */
export function Presenca() {
  const online = useColaboracao((s) => s.online);
  const pessoas = useColaboracao((s) => s.presenca);
  if (!online) {
    return (
      <span className="presenca presenca--offline" role="status">
        <WifiOff size={14} aria-hidden /> Reconectando…
      </span>
    );
  }
  const extras = pessoas.length - VISIVEIS;
  return (
    <ul className="presenca" aria-label={`${pessoas.length} ${pessoas.length === 1 ? 'pessoa' : 'pessoas'} no quadro agora`}>
      {pessoas.slice(0, VISIVEIS).map((p) => (
        <li key={p.uuid}>
          <Avatar nome={p.nome} chave={p.uuid} tamanho={30} />
        </li>
      ))}
      {extras > 0 && <li className="presenca__mais">+{extras}</li>}
    </ul>
  );
}
